let socket
const url = '127.0.0.1'
const port = 1919

function initSocket() {
  if (!window.WebSocket) {
    console.error('请使用火狐或谷歌浏览器！')
    return
  }
  const isDefined =
    socket &&
    typeof socket !== 'undefined' &&
    socket.readyState === WebSocket.OPEN
  if (isDefined) {
    return
  }
  socket = new WebSocket('ws://' + url + ':' + port + '')
  socket.onclose = function(event) {}
  socket.onerror = function(event) {}
}

initSocket()

export default socket
